module.exports = __webpack_public_path__ + "static/media/crown.5a68cda4.svg";